import { startMultipleDrag } from "./util/dragAndDrop/DragRegistry.js";

export {
	// eslint-disable-next-line import/prefer-default-export
	startMultipleDrag,
};
